import React from "react";
import { qhseBg, services41 } from "../../../../assets/images";
import { useTranslation } from "react-i18next";
import SubOtherHero from "../../../../Components/Breadcrumb/SubOtherHero/SubOtherHero";

const DirectionalSupply = () => {
  const { t } = useTranslation();

  return (
    <>
      <div
        className="bg-black/60"
        style={{
          position: "relative",
          overflow: "hidden",
          backgroundImage: `url(${qhseBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "100%",
          height: window.innerWidth < 640 ? "200px" : "300px",
        }}
      >
        <SubOtherHero title="Directional drilling" />
      </div>

      <div className="bg-[#EDEDED] py-10 md:py-20">
        <div className="max-w-containerSm md:max-w-container mx-auto md:flex md:items-start md:justify-between gap-10 flex-col md:flex-row">
          {/* Left Text */}
          <div className="md:w-2/3">
            <p className="text-[22px] md:text-[44px] font-bold text-[#141615] font-firstFont">
              {t("DIRECTIONAL DRILLING Downhole Motors")}
            </p>
            <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
              {t(
                "The Caspian Rock Solutions company is pleased to offer you downhole drilling motors of any modifications and standard sizes. They are designed for vertical, directional or horizontal drilling."
              )}
            </p>

            <p className="mt-6 text-[20px] font-semibold text-[#141615]">
              {t("Advantages")}
            </p>
            <ul className="mt-4 text-[14px] md:text-[20px] text-[#41444B] list-disc list-inside space-y-3">
              <li>{t("Range of motor dimensions 102 … 244 mm")}</li>
              <li>
                {t(
                  "Optimal size combined with reliability, sufficient controllability and rigidity;"
                )}
              </li>
              <li>
                {t(
                  "The quality and reliability of downhole drilling motors will allow you to solve work tasks as quickly and efficiently as possible, as well as saving labor and money resources;"
                )}
              </li>
              <li>
                {t(
                  "The motors are equipped with carbide bushings and bearings, which are characterized by increased reliability and service life, a hinge device, as well as bearings with an increased service life made of special steel that can withstand high loads, working pairs with high torque and mechanical speed;"
                )}
              </li>
            </ul>
          </div>

          {/* Right Image */}
          <div className="md:w-1/3 mt-8 md:mt-0">
            <img
              src={services41}
              alt="Drill Bit 1"
              className="w-full rounded-lg shadow-md"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default DirectionalSupply;
